// src/app/slices/adpGageSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { deleteAccessory } from './actions';
import { AccessoryState, IAdpGage, IAdpGageParams } from '../models';

const initialState: AccessoryState<IAdpGage, IAdpGageParams> = {
  accessories: {},
  params: null,
};

const adpGageSlice = createSlice({
  name: 'adp_gage',
  initialState,
  reducers: {
    setAdpGage: (state, action: PayloadAction<IAdpGage>) => {
      if (!state.accessories[action.payload.section_id])
        state.accessories[action.payload.section_id] = {};
      state.accessories[action.payload.section_id][action.payload.id] =
        action.payload;
    },
    setAdpGageParams: (state, action: PayloadAction<IAdpGageParams>) => {
      state.params = action.payload;
    },
    deleteAdpGage: deleteAccessory,
  },
});

export const { setAdpGage, setAdpGageParams, deleteAdpGage } = adpGageSlice.actions;

export default adpGageSlice.reducer;
